module.exports = __webpack_public_path__ + "img/icon-folder-source.aeb87e1c.svg";